







































































import { defineComponent, PropType, ref, watch } from '@vue/composition-api';
import { badgesHeadersData } from '@/bundles/Badge/helpers';
import { ITableOptions } from '@/bundles/BaseTable/interfaces';
import { useBadge } from '@/bundles/Badge/composables/useBadge';
import { IBadge } from '@/bundles/Badge/interfaces';

import BaseTable from '@/bundles/BaseTable/components/BaseTable.vue';
import BadgeEditForm from '@/bundles/Badge/components/BadgeEditForm.vue';

export default defineComponent({
  name: 'BadgesListTable',

  components: {
    BaseTable,
    BadgeEditForm,
  },

  emits: ['options:change', 'badge:refresh'],

  props: {
    tableOptionsEntry: {
      type: Object,
      required: true,
    },
    itemsEntry: {
      type: Array as PropType<IBadge[]>,
      default: () => [],
    },
    totalRowsEntry: {
      type: Number,
      default: 0,
    },
    loading: Boolean,
  },

  setup: function (props, { emit }) {
    function calculateHeight() {
      const total = window.innerHeight;
      const header = document.querySelector('.v-app-bar--fixed');
      const elementsHeight = (header as HTMLElement)?.offsetHeight + 64;
      // @ts-ignore
      return total - elementsHeight - (this.$vuetify.breakpoint.xs ? -55 : 0);
    }

    function optionsChangeEventHandler(options: ITableOptions) {
      emit('options:change', options);
    }

    const showEditForm = ref(false);
    const { badge, resetBadge } = useBadge();
    function openEditForm (item: IBadge) {
      badge.value = { ...item };
      showEditForm.value = true;
    }
    watch(showEditForm, function (value: boolean) {
      if (!value) {
        resetBadge();
      }
    });
    function refreshEventHandler (badge: IBadge) {
      showEditForm.value = false;
      emit('badge:refresh', badge);
    }

    function iconUpdateHandler ({ url }: { url: string }) {
      badge.value = { ...badge.value, icon: url };
    }

    function iconResetHandler () {
      const selectedBadgeIcon = props.itemsEntry.find((item) => item.id === badge.value.id)?.icon;

      badge.value = { ...badge.value, icon: selectedBadgeIcon as string };
    }

    return {
      badgesHeadersData,
      showEditForm,
      badge,
      openEditForm,
      calculateHeight,
      optionsChangeEventHandler,
      refreshEventHandler,
      iconUpdateHandler,
      iconResetHandler
    };
  },
});
